const ShotDrinkMass = [
  {
      id:1,
      title:"Пухлина мозку",
      price:"140 грн",
      src: require('../img/cancerBrain.png'),
      text:`Самбука, 
Мартіні,
Бейлис,
Гренадін`,
//  isHalloween: true
  },
  // {
  //     id:1,
  //     title:"План «Капкан»",
  //     price:"145 грн",
  //     src: require('../img/kap.webp'),
  //     text:"самбука, вершковий лікер, текіла, сироп Блю Кюрасао",
  // },
  {
    id: 2,
    title: 'Gold Oasis',
    price: '150 грн',
    src: require('../img/GoldOasis.png'),
   
    text: `Jägermeister orange, 
Aperol,
Сироп Маракуя`,
 isNew: true,
  },
  {
    id: 3,
    title: 'Yumi',
    price: '140 грн',
    src: require('../img/Yumi.png'),
    isNew: true,
    text: `Лікер персик,
Сік апельсину, 
Ром золотий,`,
  },
  {
    id: 4,
    title: 'Never fake',
    price: '140 грн',
    src: require('../img/Neverfake.png'),
    text: 'Лікер вишні, сік апельсину, егермейстер',
  },
  {
    id: 5,
    title: 'Другий поверх',
    price: '140 грн',
    src: require('../img/secondfloor.png'),
    text: 'Лікері вишні, сік лимону, джин',
  },
  {
    id: 6,
    title: 'Easy me',
    price: '140 грн',
    src: require('../img/Easyme.png'),
    text: 'Лікер персику, сік апельсину , лікер апельсину',
  },
  // {
  //     id:7,
  //     title:"Бісквіт",
  //     price:"140 грн",
  //     src: require('../img/biskvit.png'),
  //     text:"Лікер персику, Бейліс, золотий ром",
  // },
  {
    id: 8,
    title: 'Рідкий асфальт',
    price: '140 грн',
    src: require('../img/asf.webp'),
    text: 'самбука, Jägermeister, абсент',
  },
  {
    id: 9,
    title: 'Б-52',
    price: '140 грн',
    src: require('../img/b.webp'),
    text: 'кавовий лікер, вершковий лікер, апельсиновий лікер',
  },
  {
    id: 10,
    title: 'Хіросіма',
    price: '140 грн',
    src: require('../img/hiro.webp'),
    text: 'абсент, самбука, вершковий лікер, гранатовий сироп',
  },
  {
    id: 11,
    title: 'Медуза',
    price: '140 грн',
    src: require('../img/meduza.webp'),
    text: 'ром білий, кокосовий лікер, апельсиновий лікер, вершковий лікер, лікер Блю Кюрасао',
  },
  {
    id: 12,
    title: 'Зелений мексиканець',
    price: '140 грн',
    src: require('../img/mex.webp'),
    text: 'текіла, банановий лікер, лимонний фреш',
  },
  {
    id: 13,
    title: 'фірмовий шот від Orange ',
    price: '99 грн',
    src: require('../img/firmshot.png'),
    text: 'сироп, сік, народний коктейль',
  },
  {
    id: 14,
    title: 'Текіла Бум ',
    price: '220 грн',
    src: require('../img/bumka.webp'),
    text: 'текіла, лимонній фреш 7up',
  },
  {
    id: 15,
    title: 'Бандітос ',
    price: '160 грн',
    src: require('../img/band.webp'),
    text: 'текіла, кавовий лікер, лимонний фреш',
  },
];

export default ShotDrinkMass;
